export default __webpack_public_path__ + "static/media/Gymnastics Hall, Ambala5.75a944ca.jpg";